/**
 * json-codec.js — el codec UNICO de (de)serializacion JSON<->TEXT de offline-v2 (CAP-bind-safety).
 *
 * Por que existe: las columnas TEXT de SQLite (answers.value/extra_properties, addons.answer,
 * tasks.*, etc.) NO saben bindear un objeto/array crudo -> el plugin lanza
 * "Unsupported bind() argument type: object" y la fila (y su outbox) NUNCA se escriben, mientras
 * la foto ya quedo en PhotoStore -> huerfana. La cura es serializar objetos/arrays a JSON TEXT en
 * el WRITE-side y re-parsear en el READ-side, de forma SIMETRICA.
 *
 * ALTITUD CORRECTA (fix bind-safety): el write-side `toText` vive aqui y lo consume
 * BaseRepository._buildUpsert -> TODO repo (answers/addons/signatures/tasks/task_evidence/
 * occurrences) bindea seguro sin guard local. El read-side `parseMaybeJson` tambien vive aqui y lo
 * consume sync/modules/occurrences.js. Tener AMBOS lados en el MISMO modulo mata el riesgo de drift
 * (que un lado serialice y el otro no des-serialice).
 */

/**
 * WRITE-side: convierte un valor a algo que SQLite puede bindear.
 * - objeto/array (no-null) -> JSON.stringify (TEXT).
 * - escalares (string/number/boolean/null/undefined) -> tal cual.
 * Idempotente para escalares: NUNCA hace doble-stringify (solo toca typeof === 'object').
 * @param {*} v
 * @returns {*}
 */
export function toText (v) {
  return (v !== null && typeof v === 'object' ? JSON.stringify(v) : v)
}

/**
 * READ-side: re-parsea un TEXT que PUDIERA ser JSON de objeto/array.
 * - no-string (ya parseado, number, null) -> tal cual.
 * - string que empieza con '{' o '[' -> intenta JSON.parse; si falla, deja el crudo.
 * - cualquier otro string (escalar serializado) -> tal cual.
 * @param {*} raw
 * @returns {*}
 */
export function parseMaybeJson (raw) {
  if (raw == null || typeof raw !== 'string') return raw
  const trimmed = raw.trim()
  if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) return raw
  try {
    return JSON.parse(trimmed)
  } catch {
    return raw
  }
}
